import CacheBase2 from '../../../services/engines/CacheBase2';

class FormConfigCache extends CacheBase2 {
    initialize() {
        this._name = 'FormConfigCache';
    }
}

const formConfigCache = new FormConfigCache();
export default formConfigCache;
